import { Button, Grid } from '@material-ui/core/';
import * as Sentry from '@sentry/react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { SeverityLevel_error } from '~/constant.js';
import { setUserAddressError } from '~/store/legacy/actions/userActions.js';
import { getUserStore } from '~/store/legacy/selector/userSelectors.js';
import { mixpanel } from '~/third_party/Mixpanel.jsx';
import CurrentAddress from './address/CurrentAddress.jsx';
import useStyles from './DeliveryAddressInput.style';

export default DeliveryAddressInput;

function DeliveryAddressInput(props) {
  const router = useRouter();
  const dispatch = useDispatch();
  const intl = useIntl();
  const { address, addressError } = useSelector(getUserStore);
  const classes = useStyles();
  const redirect = () => {
    if (!address) {
      mixpanel.track({
        name: 'click order now',
        properties: { address: '' },
      });
      mixpanel.track({ name: 'change address navigation', properties: { addressType: 'error' } });
      mixpanel.track({
        name: 'change address navigation',
        properties: { source: 'DeliveryAddressInput', addressType: 'error' },
      });
      Sentry.captureMessage(
        'Attempt to navigate to address failed in DeliveryAddressInput',
        SeverityLevel_error,
      );
      dispatch(setUserAddressError(intl.formatMessage({ id: 'actions.user.address.error.alert' })));
      return;
    }

    if (!address.address_1) {
      mixpanel.track({ name: 'click order now', properties: { address } });
      mixpanel.track({
        name: 'change address navigation',
        properties: { source: 'DeliveryAddressInput', addressType: 'regional' },
      });
      dispatch(setUserAddressError(null));
      router.push(
        `/delivery/[address]`,
        `/delivery/${address.city},${address.state} ${address.country}`
      );
    } else {
      mixpanel.track({
        name: 'click order now',
        properties: { address, addressType: 'deliverable' },
      });
      mixpanel.track({
        name: 'change address navigation',
        properties: { source: 'DeliveryAddressInput', addressType: 'deliverable' },
      });
      dispatch(setUserAddressError(null));
      router.push(`/delivery/[address]`, `/delivery/${address.address_1}`);
    }
  };

  return (
    <Grid container className={classNames(classes.wrapper)} alignItems='center' justify='center'>
      <Grid
        item
        className={classNames(classes.inputContainer, {
          [classes.inputOutlineError]: addressError,
        })}
        style={{ padding: 0 }}>
        <CurrentAddress />
      </Grid>
      <Grid item className={classes.buttonContainer} style={{ padding: 0 }}>
        <Button onClick={redirect} className={`${classes.textButton} order-now`} color='primary'>
          {props.callToAction}
        </Button>
      </Grid>
    </Grid>
  );
}
